import classNames from "classnames";
import React from "react";

export function KeyboardShortcutIndicator({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={classNames(
        "flex items-center justify-center text-neutral-400",
        className
      )}
    >
      {children}
    </div>
  );
}
